import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 16,
    marginTop: 16,
    marginBottom: 16,
    borderBottom: `1px solid ${theme.palette.colors.divider}`,
    '&:last-child': {
      borderBottom: 'none',
      marginBottom: 0,
    },
  },
  loanOfficerInfo: {
    marginLeft: 16,
    display: 'flex',
    flexDirection: 'column',
    '& h6': {
      marginBottom: 8,
    },
  },
  avatar: {
    marginLeft: 24,
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/components/BulkMessaging/components/LoanOfficerCard/useStyles.js